<script setup>
import Input from 'dashboard/components-next/input/Input.vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import CompanySortMenu from './components/CompanySortMenu.vue';
import CompanyMoreActions from './components/CompanyMoreActions.vue';

defineProps({
  showSearch: { type: Boolean, default: true },
  searchValue: { type: String, default: '' },
  headerTitle: { type: String, required: true },
  activeSort: { type: String, default: 'last_activity_at' },
  activeOrdering: { type: String, default: '' },
});

const emit = defineEmits(['search', 'update:sort', 'create']);
</script>

<template>
  <header
    class="sticky top-0 z-20 border-b border-auth-border bg-auth-canvas/95 px-3 dark:border-auth-border-dark dark:bg-auth-canvas-dark/95 sm:px-5 lg:px-6"
  >
    <div
      class="mx-auto flex w-full max-w-6xl items-start justify-between gap-3 py-4 sm:items-center sm:py-5"
    >
      <span
        class="min-w-0 truncate text-xl font-semibold tracking-[-0.025em] text-auth-text dark:text-auth-text-dark sm:text-2xl"
      >
        {{ headerTitle }}
      </span>
      <div
        class="flex flex-shrink-0 flex-col items-end gap-3 sm:flex-row sm:items-center"
      >
        <div v-if="showSearch" class="flex w-full items-center gap-2 sm:w-64">
          <Input
            :model-value="searchValue"
            type="search"
            :placeholder="$t('COMPANIES.SEARCH_PLACEHOLDER')"
            :custom-input-class="[
              'h-9 !rounded-xl !border-auth-border !bg-auth-soft !py-1 !ps-9 !pe-3 !text-auth-text placeholder:!text-auth-muted focus:!border-auth-action dark:!border-auth-border-dark dark:!bg-auth-soft-dark dark:!text-auth-text-dark dark:placeholder:!text-auth-muted-dark dark:focus:!border-auth-accent',
            ]"
            class="w-full"
            @input="emit('search', $event.target.value)"
          >
            <template #prefix>
              <Icon
                icon="i-lucide-search"
                class="absolute start-3 top-1/2 size-4 -translate-y-1/2 text-auth-muted dark:text-auth-muted-dark"
              />
            </template>
          </Input>
        </div>
        <div
          class="flex flex-shrink-0 items-center gap-2 [&_button]:focus-visible:!outline [&_button]:focus-visible:!outline-2 [&_button]:focus-visible:!outline-offset-2 [&_button]:focus-visible:!outline-auth-action dark:[&_button]:focus-visible:!outline-auth-accent"
        >
          <CompanySortMenu
            :active-sort="activeSort"
            :active-ordering="activeOrdering"
            @update:sort="emit('update:sort', $event)"
          />
          <CompanyMoreActions @create="emit('create')" />
        </div>
      </div>
    </div>
  </header>
</template>
